import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import dynamic from 'next/dynamic';
var DynamicReactJson = dynamic(function () {
  return import('react-json-view');
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('react-json-view')];
    },
    modules: ["../components/commons/JsonLog.tsx -> " + 'react-json-view']
  }
});

var JsonLog = function JsonLog(_ref) {
  var _ref$json = _ref.json,
      json = _ref$json === void 0 ? null : _ref$json,
      _ref$src = _ref.src,
      src = _ref$src === void 0 ? null : _ref$src,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'JSON' : _ref$title,
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === void 0 ? 2 : _ref$collapsed,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible;
  //const user = useCurrentUser()
  //console.log('props json', json);
  //if (user.role.name !== "Admin") return null;
  if (!json && !src) return null;
  return /*#__PURE__*/_jsx("span", {
    className: "jsonLog debug  ".concat(visible ? '' : 'hidden'),
    children: /*#__PURE__*/_jsx(DynamicReactJson, {
      src: json || src,
      collapsed: collapsed,
      name: title
    })
  });
};

export default JsonLog;